import { type ChangeEvent, type FC, useRef } from 'react';
import { Input } from '@THC/components/Input';
import debounce from 'lodash/debounce';
import { useStore } from 'zustand';

import { MagnifyingGlassIcon } from '@motorway/mw-highway-code';

import { useClearButtonEventTrigger } from 'Features/SellerCommunications/hooks/useClearButtonEventTrigger';
import { EnquiriesSearchStore, enquirySelectionService } from 'Features/SellerCommunications/services';
import { T } from 'Features/SellerCommunications/utils/translate';
import {
	triggerSellerMessagingSearchInputClickedEvent,
	triggerSellerMessagingSearchQuerySubmittedEvent,
} from 'Services/analytics/events';

export const SEARCH_DELAY = 500;

export const EnquirySelectionListSearch: FC = () => {
	const search = useStore(EnquiriesSearchStore, (state) => state.search);

	const debouncedOnSearch = useRef(
		debounce((value: string) => {
			if (value) {
				triggerSellerMessagingSearchQuerySubmittedEvent(value);
			}
			enquirySelectionService.onSearchChange(value);
		}, SEARCH_DELAY),
	).current;

	useClearButtonEventTrigger();

	return (
		<Input
			fullWidth
			formProps={{
				input: {
					onChange: (e: ChangeEvent<HTMLInputElement>) => {
						enquirySelectionService.onSetSearch(e.target.value);
						debouncedOnSearch(e.target.value);
					},
					onFocus: triggerSellerMessagingSearchInputClickedEvent,
					type: 'search',
					value: search ?? '',
				},
			}}
			id="seller-comms-search"
			label={`${T.translate('enquiryList.searchField.label')}`}
			placeholder={`${T.translate('enquiryList.searchField.placeholder')}`}
			prepend={MagnifyingGlassIcon}
		/>
	);
};
